import { DatastoreObjectType } from "@iotv/iotv-v3-types"

export const existsFilter = <T = any>(x: T | null | undefined): x is T => !!x

export const getTypeFilter = (type: string) => (x: { type?: string }) => x.type === type

type GetRejectionBucketingFilterInput<T> = {
  rejectionsBucket: T[]
  filter: (item: T) => boolean
}

/** returns a filter that will dump rejections that FAIL the filter into provided bucket
 * @typeParam T - Type of item to be filterd and type of rejection bucket array
 * @param filter - The filter to run on provided items
 * @param rejectionsBucket - An array to push filterd items to
 * @returns A filter function that pushes failed items to an array
 * @example
 * Filtering a list of objects and getting everything that isn't a dog
 * ```
 * const notDogs: any[] = [];
 * const dogFilter = getRejectionBucketingFilter({ filter: item => item.type === 'Dog', rejectionsBucket: notDogs });
 * const dogs = [unfilteredItems].filter(dogFilter);
 * ```
 * */
export const getRejectionBucketingFilter =
  <T>({ filter, rejectionsBucket }: GetRejectionBucketingFilterInput<T>) =>
  (item: T): boolean => {
    const passes = filter(item)
    if (!passes) {
      rejectionsBucket.push(item)
    }
    return passes
  }


export type VOBFilter = ( vob: DatastoreObjectType ) => boolean
export const andVobFilter = ( filters: VOBFilter[] ): VOBFilter  => ( vob: DatastoreObjectType ) => filters.map( ( filter ) => filter(vob) ).every( (res) => !!res)

/** produces a single 'and' filter for vobs from a set of vob filters */
export const orVobFilter = ( filters: VOBFilter[] ): VOBFilter  => ( vob: DatastoreObjectType ) => filters.map( ( filter ) => filter(vob) ).some( (res) => !!res)
